import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// VO == on-screen caption. Every claim is grounded in EAKC-MVP's 2026-06-14 session.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5, caption: "My RAG was slow, expensive, and sometimes made up its own citations. So I kept fixing it." },
  { scene: "hook", fromSec: 5.5, holdSec: 4.5, caption: "Tweak a setting for one kind of question — and break a different kind. Retune. Repeat. A hundred times." },
  { scene: "hook", fromSec: 10.2, holdSec: 3.5, caption: "I was tuning by feel. The number of knobs WAS the disease. So I stopped guessing." },
];

export const MEASURE: ScriptLine[] = [
  { scene: "measure", fromSec: 0.3, holdSec: 6, caption: "I already had an eval suite. I'd just never turned it on. You can't fix what you don't measure." },
  { scene: "measure", fromSec: 6.5, holdSec: 6, caption: "First real baseline: twenty-two of twenty-three pass — but pass/fail was the wrong signal." },
  { scene: "measure", fromSec: 13, holdSec: 4.5, caption: "The honest numbers were latency — about seven seconds — and an average relevance of 0.43. That's the line in the sand." },
];

export const COST: ScriptLine[] = [
  { scene: "cost", fromSec: 0.3, holdSec: 6, caption: "First the money. Five dollars a week — and it wasn't the embeddings." },
  { scene: "cost", fromSec: 6.5, holdSec: 5.5, caption: "A flag was ON that writes a one-sentence 'context note' with an LLM for EVERY new chunk at sync time." },
  { scene: "cost", fromSec: 12.3, holdSec: 3.4, caption: "Seventeen thousand new chunks that week meant seventeen thousand LLM calls. One config flip — off." },
];

export const THINGATE: ScriptLine[] = [
  { scene: "thingate", fromSec: 0.3, holdSec: 6, caption: "Then the speed. A 'backup' search step ran on EVERY query, padding results for no quality gain — plus a database typo made it fail silently." },
  { scene: "thingate", fromSec: 6.5, holdSec: 6, caption: "I fixed the typo. And my fix made it SLOWER — plus 1.7 seconds. I'd traded a fast failure for slow, useless work." },
  { scene: "thingate", fromSec: 13, holdSec: 4.7, caption: "The eval caught me. So I added a rule: only dig when the basket is nearly empty. Latency back down, quality held." },
];

export const DOUBT: ScriptLine[] = [
  { scene: "doubt", fromSec: 0.3, holdSec: 6, caption: "Then one question took sixty-seven seconds. Forty-one of them were a single step: the quality gate." },
  { scene: "doubt", fromSec: 6.5, holdSec: 6, caption: "It second-guesses retrieval — and when it's unsure, it re-runs the ENTIRE search twice. A broad pass, then an 'imagine the answer' pass." },
  { scene: "doubt", fromSec: 13, holdSec: 4.7, caption: "Seventeen seconds, then twenty-one. The catch: it already had four perfect sources. The re-searches changed nothing." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.3, holdSec: 6, caption: "Measure, then cut. Rule one: if the results are clearly strong, trust them — skip both re-searches." },
  { scene: "fix", fromSec: 6.5, holdSec: 6, caption: "Rule two: if it's only a little unsure, do ONE cheap recheck — never the expensive 'imagine the answer' pass." },
  { scene: "fix", fromSec: 13, holdSec: 4.7, caption: "Save that one for when the search found nothing. The forty-one-second step collapses to about two — same answer, same sources." },
];

export const LESSON: ScriptLine[] = [
  { scene: "lesson", fromSec: 0.3, holdSec: 6, caption: "Every clever, adaptive layer helps some questions and quietly hurts others. The more you stack, the more they fight." },
  { scene: "lesson", fromSec: 6.5, holdSec: 5.5, caption: "The way off the treadmill isn't more tuning. It's deleting layers until what's left is boring and robust — measured at every step." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.3, holdSec: 5, caption: "One golden eval. One change at a time. Keep it only if the number agrees." },
  { scene: "outro", fromSec: 5.5, holdSec: 3.8, caption: "Stop guessing. It's all open — the repo, the eval, the dashboard. Build in public, measure in public." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
